import { Col, Row } from 'reactstrap';

import CourseActivityTypeSection from '../sections/CourseActivityTypeSection';
import CourseAttendanceSection from '../sections/CourseAttendanceSection';
import CourseCompatibilitiesSection from '../sections/CourseCompatibilitiesSection';
import CourseDetailsSection from '../sections/CourseDetailsSection';
import CoursePrerequisitesSection from '../sections/CoursePrerequisitesSection';

const CourseAdministrativeTab = () => {
  return (
    <>
      <CourseDetailsSection />
      <CourseActivityTypeSection />
      <Row className="pt-4">
        <Col xs={12} md={4}>
          <CourseAttendanceSection />
        </Col>
        <Col xs={12} md={8}>
          <CoursePrerequisitesSection />
        </Col>
        <Col xs={12}>
          <CourseCompatibilitiesSection />
        </Col>
      </Row>
    </>
  );
};

export default CourseAdministrativeTab;
